import type { EnvConfig } from 'config';
import development from './development';
import production from './production';

const developmentProd: EnvConfig = {
  ...production,
  appHost: development.appHost,
};

export default developmentProd;
